module.exports = __webpack_public_path__ + "img/28.d2c36ef9.jpg";